import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  padding-bottom: ${props => props.ratio};
  height: 0;
`

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const VideoContainer = ({ source, ratio = '56.25%' }) => (
  <Container ratio={ratio}>
    <Video src={source} frameBorder="0" webkitAllowFullScreen mozAllowFullScreen allowFullScreen />
  </Container>
)

VideoContainer.propTypes = {
  source: string.isRequired,
  ratio: string
}

export default VideoContainer
